import { Link } from "@tanstack/react-router";
import ChevronRight from "~icons/material-symbols/chevron-right";
import Face from "~icons/material-symbols/face-outline";
import { css } from "../../../../styled-system/css";
import { t } from "../../../libs/i18n";

export const InvitationLinkCard = () => {
  return (
    <Link
      to="/invitation"
      className={css({
        display: "flex",
        alignItems: "center",
        gap: "12px",
        bg: "surface.primary",
        border: "1px solid",
        borderColor: "border.secondary",
        rounded: "16px",
        px: "16px",
        py: "16px",
        textDecoration: "none",
        color: "inherit",
      })}
    >
      <Face
        className={css({
          fontSize: "20px",
          color: "text.primary",
          flexShrink: 0,
        })}
      />
      <div
        className={css({
          flex: 1,
          fontSize: "16px",
          color: "text.primary",
          lineHeight: "1.5",
        })}
      >
        {t("友だち紹介")}
      </div>
      <ChevronRight
        className={css({
          fontSize: "24px",
          color: "text.tertiary",
          flexShrink: 0,
        })}
      />
    </Link>
  );
};
